/* Meu Xodó — foto da EMBALAGEM (06/10/2026).
   Cena + 1 ou 2 fotos → o servidor (ERP) devolve o cartão que vai na janela da caixa.
   Só cliente logado gera; o servidor confere o login assinado e o saldo de gerações. */
(function () {
  var raiz = document.querySelector('[data-xodo-caixa]');
  if (!raiz) return;
  var q = function (s) { return raiz.querySelector(s); };
  var el = {
    arquivo: q('[data-xodoc-arquivo]'), fotos: q('[data-xodoc-fotos]'), escolher: q('[data-xodoc-escolher]'), escolherTxt: q('[data-xodoc-escolher-txt]'),
    criar: q('[data-xodoc-criar]'), saldo: q('[data-xodoc-saldo]'), semSaldo: q('[data-xodoc-sem-saldo]'), status: q('[data-xodoc-status]'),
    erro: q('[data-xodoc-erro]'), pronto: q('[data-xodoc-pronto]'), refazer: q('[data-xodoc-refazer]'), aviso: q('[data-xodoc-aviso-compra]'),
    previa: q('[data-xodoc-previa]'), cartao: q('[data-xodoc-cartao]'), selo: q('[data-xodoc-selo]'),
    propCena: q('[data-xodoc-prop-cena]'), propGeracao: q('[data-xodoc-prop-geracao]'), propArquivo: q('[data-xodoc-prop-arquivo]')
  };
  var NOMES = { cerveja: 'Cervejinha na praia', futevolei: 'Futevôlei', bicicleta: 'Bicicleta a dois', brincando: 'Brincando na praia', judo: 'Indo pro judô', cachorro: 'Com meu cachorro', namorados: 'Namorados', pais: 'Pais e filhos', avo: 'Com o vovô', sogra: 'Com a sogra', sogro: 'Com o sogro', gato: 'Com meu gato' };
  var DICAS = { cachorro: 'Uma foto do seu rosto sorrindo e uma do seu bicho de corpo inteiro.', passeio: 'Uma foto do seu rosto sorrindo e uma do seu bicho de corpo inteiro.', colo: 'Uma foto do seu rosto sorrindo e uma do seu bicho de corpo inteiro.', gato: 'Uma foto do seu rosto sorrindo e uma do seu bicho de corpo inteiro.' };
  var DICA_PADRAO = 'Uma foto do rosto de cada um, sorrindo.';
  var dica = q('[data-xodoc-dica]'), frente = q('[data-xodoc-frente]');
  var PASSOS = ['Enviando as fotos', 'Encontrando vocês dois', 'Recortando no estilo da coleção', 'Montando a cena no Rio', 'Colocando na caixa'];
  var api = raiz.getAttribute('data-api');
  var login = raiz.getAttribute('data-t') ? { c: raiz.getAttribute('data-c'), ts: raiz.getAttribute('data-ts'), t: raiz.getAttribute('data-t') } : null;
  var conta = { gratis: null, creditos: 0, pode: true };
  var estado = { cena: 'namorados', para: 'amor', arquivos: [], pronto: false, gerando: false };
  var area = raiz.closest('.product__content') || document;
  var botaoComprar = area.querySelector('button[name="add"]');

  // A caixa vai para a coluna da esquerda (galeria), grande e fixa enquanto a pessoa monta do lado direito.
  var galeria = document.querySelector('product-images, .product__images');
  if (galeria) {
    var palco = document.createElement('div'); palco.className = 'xodoc__palco';
    var leg = document.createElement('p'); leg.className = 'xodoc__palco-legenda'; leg.textContent = 'É assim que a sua caixa vai ficar';
    palco.appendChild(el.previa); palco.appendChild(leg);
    // Vídeo 3D das duas caixas: alterna com a prévia, só carrega quando a pessoa pede.
    var urlVideo = raiz.getAttribute('data-video');
    if (urlVideo) {
      var abas = document.createElement('div'); abas.className = 'xodoc__abas';
      abas.innerHTML = '<button type="button" class="is-on" data-xodoc-aba="previa">Sua caixa</button><button type="button" data-xodoc-aba="video">Ver em 3D</button>';
      var video = document.createElement('video'); video.className = 'xodoc__video'; video.muted = true; video.loop = true; video.playsInline = true; video.setAttribute('playsinline', ''); video.preload = 'none'; video.hidden = true;
      palco.insertBefore(video, leg); palco.appendChild(abas);
      abas.addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-xodoc-aba]'); if (!b) return;
        var v = b.getAttribute('data-xodoc-aba') === 'video';
        Array.prototype.forEach.call(abas.children, function (o) { o.classList.toggle('is-on', o === b); });
        el.previa.hidden = v; video.hidden = !v; leg.textContent = v ? 'A caixa Meu Xodó: cabe 1 camiseta' : 'É assim que a sua caixa vai ficar';
        if (v) { if (!video.src) video.src = urlVideo; video.play().catch(function () {}); } else video.pause();
      });
    }
    galeria.insertBefore(palco, galeria.firstChild);
    document.body.classList.add('xodoc-pagina');
  }
  var trilho = q('.xodoc__cenas'), cenaNome = q('[data-xodoc-cena-nome]');
  function setas() {
    var e = q('[data-xodoc-seta="-1"]'), d = q('[data-xodoc-seta="1"]'); if (!trilho || !e) return;
    e.disabled = trilho.scrollLeft < 8; d.disabled = trilho.scrollLeft + trilho.clientWidth > trilho.scrollWidth - 8;
  }
  Array.prototype.forEach.call(raiz.querySelectorAll('[data-xodoc-seta]'), function (b) {
    b.addEventListener('click', function () { trilho.scrollBy({ left: parseInt(b.getAttribute('data-xodoc-seta'), 10) * trilho.clientWidth * 0.8, behavior: 'smooth' }); });
  });
  if (trilho) { trilho.addEventListener('scroll', setas, { passive: true }); window.addEventListener('resize', setas); setTimeout(setas, 300); }

  var XODO_PAUSA = false, XODO_EMAIL = 'contato@lab77.com.br';
  /* 02/11 plano B: erro da geração mostra o e-mail; XODO_PAUSA = chave de emergência (xodo-plano-b.sh pausa|normal). */
  function erro(msg, email) {
    if (msg && msg.message) msg = msg.message;
    el.erro.textContent = msg || '';
    if (msg && email) {
      var a = document.createElement('a');
      a.href = 'mailto:' + XODO_EMAIL + '?subject=' + encodeURIComponent('Meu Xodó: quero meu desenho') + '&body=' + encodeURIComponent('Olá! Não consegui criar meu desenho no site.\n\nProduto: ' + location.origin + location.pathname + '\nNome que vai na arte (se tiver): \nTamanho: \n\nMinhas fotos vão em anexo.');
      a.textContent = XODO_EMAIL; a.style.textDecoration = 'underline';
      el.erro.appendChild(document.createElement('br'));
      el.erro.appendChild(document.createTextNode('Se preferir, mande suas fotos para '));
      el.erro.appendChild(a);
      el.erro.appendChild(document.createTextNode(' e a gente desenha para você e responde em até 24 horas.'));
    }
    el.erro.hidden = !msg;
  }
  var XODO_PAUSA_MSG = 'Nosso desenhista está numa pausa rápida agora.';
  if (XODO_PAUSA) setTimeout(function () { erro(XODO_PAUSA_MSG, true); }, 0);
  function pintarFotos() {
    el.fotos.innerHTML = '';
    estado.arquivos.forEach(function (a, i) {
      var d = document.createElement('div'); d.className = 'xodoc__foto';
      var img = document.createElement('img'); img.src = a.url; img.alt = 'Foto ' + (i + 1); img.width = 64; img.height = 64;
      var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', 'Remover foto ' + (i + 1)); x.textContent = '×';
      x.addEventListener('click', function () { URL.revokeObjectURL(a.url); estado.arquivos.splice(i, 1); invalidar(); pintarFotos(); atualizar(); });
      d.appendChild(img); d.appendChild(x); el.fotos.appendChild(d);
    });
    el.escolher.hidden = estado.arquivos.length >= 2;
    el.escolherTxt.textContent = estado.arquivos.length ? 'Adicionar a segunda foto (opcional)' : 'Escolher foto';
  }
  function atualizar() {
    if (xodoPend && !estado.pronto) xodoLimparPend();
    el.criar.disabled = !(login && estado.arquivos.length && conta.pode) || estado.gerando;
    if (login && conta.gratis !== null) {
      el.semSaldo.hidden = conta.pode;
      el.saldo.hidden = !conta.pode || estado.pronto;
      el.saldo.textContent = conta.gratis > 0 ? 'Você tem ' + conta.gratis + (conta.gratis === 1 ? ' geração grátis.' : ' gerações grátis.') : 'Você tem ' + conta.creditos + (conta.creditos === 1 ? ' geração.' : ' gerações.');
      el.refazer.hidden = !conta.pode;
    }
    document.body.classList.toggle('xodo-pendente', !estado.pronto);
    el.propCena.disabled = el.propGeracao.disabled = el.propArquivo.disabled = !estado.pronto; if (propPara) propPara.disabled = !estado.pronto;
    el.criar.hidden = estado.pronto; el.pronto.hidden = !estado.pronto || !!xodoPend;
    if (estado.pronto) el.aviso.hidden = true;
  }
  function invalidar() {                       // mudou cena ou foto depois de pronto: precisa gerar de novo
    if (!estado.pronto) return;
    estado.pronto = false; el.selo.hidden = false; el.selo.textContent = 'exemplo';
    var b = raiz.querySelector('[data-xodoc-cena="' + estado.cena + '"]'); if (b) el.cartao.src = b.getAttribute('data-img');
  }

  Array.prototype.forEach.call(raiz.querySelectorAll('[data-xodoc-cena]'), function (b) {
    b.addEventListener('click', function () {
      if (estado.gerando) return;
      var antes = estado.cena; estado.cena = b.getAttribute('data-xodoc-cena');
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-xodoc-cena]'), function (o) { o.classList.toggle('is-on', o === b); o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
      if (estado.pronto && antes !== estado.cena) invalidar();
      if (!estado.pronto) el.cartao.src = b.getAttribute('data-img');
      if (dica) dica.textContent = DICAS[estado.cena] || DICA_PADRAO;
      if (cenaNome) cenaNome.textContent = b.getAttribute('data-nome') || '';
      atualizar();
    });
  });

  // Passo 1: pra quem é o presente → mostra só as cenas que combinam e já marca a primeira.
  var propPara = q('[data-xodoc-prop-para]');
  function filtrar(para, manter) {
    estado.para = para; var primeira = null, atualVisivel = false;
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-xodoc-cena]'), function (b) {
      var ok = (' ' + b.getAttribute('data-para') + ' ').indexOf(' ' + para + ' ') >= 0; b.hidden = !ok;
      if (ok && !primeira) primeira = b; if (ok && b.getAttribute('data-xodoc-cena') === estado.cena) atualVisivel = true;
    });
    if (trilho) trilho.scrollLeft = 0;
    if (primeira && !(manter && atualVisivel)) primeira.click();
    setTimeout(setas, 60);
  }
  Array.prototype.forEach.call(raiz.querySelectorAll('[data-xodoc-para]'), function (b) {
    b.addEventListener('click', function () {
      if (estado.gerando) return;
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-xodoc-para]'), function (o) { o.classList.toggle('is-on', o === b); o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
      filtrar(b.getAttribute('data-xodoc-para'), false);
    });
  });
  filtrar('amor', true);

  el.escolher.addEventListener('click', function () { el.arquivo.click(); });
  el.arquivo.addEventListener('change', function () {
    erro('');
    var novos = Array.prototype.slice.call(el.arquivo.files || []);
    for (var i = 0; i < novos.length && estado.arquivos.length < 2; i++) {
      var f = novos[i];
      if (!/^image\/(jpeg|png|webp)$/.test(f.type)) { erro('Seu celular salvou a foto num formato que não conseguimos abrir. Tire um print da foto e envie o print: funciona sempre.'); continue; }
      if (f.size > 40 * 1024 * 1024) { erro('Essa foto é pesada demais. Tire um print dela e envie o print.'); continue; }
      estado.arquivos.push({ file: f, url: URL.createObjectURL(f) });
    }
    if (novos.length > 2) erro('São no máximo 2 fotos: usei as duas primeiras.');
    el.arquivo.value = ''; invalidar(); pintarFotos(); atualizar();
  });

  function aplicarSaldo(j) {
    if (!j || typeof j.gratis !== 'number') return;
    conta.gratis = j.gratis; conta.creditos = j.creditos || 0; conta.pode = !!j.pode_gerar;
  }
  // 01/11: foto reduzida no celular antes de subir + fila do servidor (o POST responde na hora com o
  // pedido; aqui pergunta até ficar pronto — o nginx corta conexões de mais de 60 s).
  function reduzir(file) {
    return new Promise(function (ok) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var s = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight)), c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * s); c.height = Math.round(img.naturalHeight * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); URL.revokeObjectURL(url);
        if (!c.toBlob) { ok(file); return; }
        c.toBlob(function (b) { ok(b && b.size < file.size ? b : file); }, 'image/jpeg', 0.88);
      };
      img.onerror = function () { URL.revokeObjectURL(url); ok(file); };
      img.src = url;
    });
  }
  function pedir(aoMudar) {
    var qs = 'c=' + encodeURIComponent(login.c) + '&ts=' + encodeURIComponent(login.ts) + '&t=' + encodeURIComponent(login.t);
    var falhar = function (j) { var e = new Error(j.erro || 'Não foi possível criar agora. Tente de novo.'); e.codigo = j.codigo; throw e; };
    return Promise.all(estado.arquivos.map(function (a) { return reduzir(a.file); })).then(function (fotos) {
      var fd = xodoFd = new FormData();
      fd.append('c', login.c); fd.append('ts', login.ts); fd.append('t', login.t); fd.append('cena', estado.cena); fd.append('assincrono', '1');
      fotos.forEach(function (f, i) { fd.append('foto', f, 'foto' + (i + 1) + '.jpg'); });
      return fetch(api + '/caixa?' + qs, { method: 'POST', body: fd });
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (r.status !== 202 || !j.pedido) { aplicarSaldo(j); if (!r.ok || !j.sucesso) falhar(j); return j; }
        var inicio = Date.now(), falhas = 0;
        return new Promise(function (ok, erro) {
          (function perguntar() {
            fetch(api + '/pedido/' + encodeURIComponent(j.pedido) + '?' + qs, { cache: 'no-store' }).then(function (r2) {
              return r2.json().catch(function () { return {}; }).then(function (k) {
                falhas = 0;
                if (r2.ok && (k.status === 'fila' || k.status === 'gerando')) {
                  if (aoMudar) aoMudar(k);
                  if (Date.now() - inicio > 8 * 60 * 1000) { erro(new Error('Está demorando mais que o normal. Tente de novo — sua geração não foi usada.'), true); return; }
                  setTimeout(perguntar, 3000); return;
                }
                aplicarSaldo(k);
                if (!r2.ok || !k.sucesso) { try { falhar(k); } catch (e) { erro(e, true); } return; }
                ok(k);
              });
            }).catch(function () { if (++falhas > 5) { erro(new Error('A conexão caiu. Confira a internet e tente de novo.'), true); return; } setTimeout(perguntar, 4000); });
          })();
        });
      });
    });
  }


  // 03/11 "não pode perder a venda": a geração falhou por algo que não é a foto → guarda as mesmas fotos no
  // servidor (sem IA, sem gastar a grátis) e libera a compra; a equipe desenha e alinha com o cliente depois.
  var xodoFd = null, xodoPend = null, xodoNota = null;
  function xodoLimparPend() {
    if (xodoPend && xodoPend.parentNode) xodoPend.parentNode.removeChild(xodoPend);
    if (xodoNota && xodoNota.parentNode) xodoNota.parentNode.removeChild(xodoNota);
    xodoPend = xodoNota = null;
  }
  function xodoOferecer(e) {
    if (!xodoFd || (e && /^(SEM_BICHO|SEM_PESSOA|FOTO|NOME|NETOS|CENA|ALTURA|RACA|ESTAMPA|LOGIN|EM_ANDAMENTO)$/.test(e.codigo || ''))) return;
    var fd = xodoFd, caixa = document.createElement('span'); caixa.style.cssText = 'display:block;margin-top:12px;color:#111';
    caixa.appendChild(document.createTextNode('Tudo bem, você não perde a sua. Pode concluir a compra: suas fotos ficam com a gente e entramos em contato com a arte da sua estampa.'));
    var b = document.createElement('button'); b.type = 'button'; b.className = 'btn btn--primary btn--solid'; b.style.cssText = 'display:block;width:100%;margin-top:10px';
    b.textContent = 'Concluir a compra e receber a arte depois'; caixa.appendChild(b);
    el.erro.appendChild(caixa); el.erro.hidden = false;
    b.addEventListener('click', function () {
      b.disabled = true; b.textContent = 'Guardando as fotos…';
      fetch(api + '/pendente', { method: 'POST', body: fd }).then(function (r) { return r.json(); }).then(function (j) {
        if (!j || !j.sucesso) throw new Error((j && j.erro) || 'Não consegui guardar as fotos.');
        return j;
      }).catch(function (err) {
        if (window.console) console.warn('[xodo] pendente', err && err.message);
        return { geracao_id: '', semFotos: true };   // a compra não pode travar aqui: o pedido avisa que faltam as fotos
      }).then(function (j) {
        erro(''); estado.pronto = true; el.propGeracao.value = j.geracao_id; el.propArquivo.value = j.semFotos ? 'PENDENTE: erro no site e as fotos não chegaram' : 'PENDENTE: erro no site, desenhar e alinhar com o cliente'; var bc = raiz.querySelector('[data-xodoc-cena="' + estado.cena + '"]'); el.propCena.value = (bc && bc.getAttribute('data-nome')) || estado.cena; if (propPara) { var bp = raiz.querySelector('.xodoc__para.is-on'); propPara.value = bp ? bp.textContent : ''; }
        xodoPend = el.propGeracao.cloneNode(false); xodoPend.name = 'properties[Desenho]'; xodoPend.value = 'A gente entra em contato com a sua arte'; xodoPend.disabled = false;
        el.propGeracao.parentNode.appendChild(xodoPend);
        xodoNota = document.createElement('p'); xodoNota.style.cssText = 'margin:12px 0;font-weight:700;color:#111';
        xodoNota.textContent = (j.semFotos ? 'Agora é só escolher o tamanho e comprar. A gente entra em contato com você para acertar as fotos e a arte da sua estampa.' : 'Fotos recebidas. Agora é só escolher o tamanho e comprar. A gente entra em contato com a arte da sua estampa.');
        el.erro.parentNode.insertBefore(xodoNota, el.erro); atualizar();
      }).catch(function (err) { b.disabled = false; b.textContent = 'Tentar de novo'; if (window.console) console.warn('[xodo] pendente', err && err.message); });
    });
  }
  function gerar() {
    if (estado.gerando || !login || !estado.arquivos.length || !conta.pode) { atualizar(); return; }
    if (XODO_PAUSA) { erro(XODO_PAUSA_MSG, true); return; } erro(''); estado.gerando = true; estado.pronto = false; el.status.hidden = false; el.previa.classList.add('is-gerando'); atualizar();
    var i = 0; el.status.textContent = PASSOS[0] + '…';
    var relogio = setInterval(function () { i = Math.min(i + 1, PASSOS.length - 1); el.status.textContent = PASSOS[i] + '…'; }, 6000);
    pedir(function (st) {
      if (st.status === 'fila' && st.posicao > 1) { clearInterval(relogio); el.status.textContent = 'Fila da foto: você é o ' + st.posicao + 'º. Leva uns ' + Math.max(2, Math.ceil(st.posicao / 5) + 1) + ' minutos. Pode deixar a tela aberta.'; }
    })
      .then(function (j) {
        el.cartao.src = j.previa_base64; el.selo.hidden = true; estado.pronto = true;
        var bc = raiz.querySelector('[data-xodoc-cena="' + j.cena + '"]'); el.propCena.value = (bc && bc.getAttribute('data-nome')) || j.cena; if (propPara) { var bp = raiz.querySelector('.xodoc__para.is-on'); propPara.value = bp ? bp.textContent : ''; } el.propGeracao.value = j.geracao_id; el.propArquivo.value = j.cartao_url;
        var r = el.previa.getBoundingClientRect();
        if (window.innerWidth < 768 && (r.top < 0 || r.bottom > window.innerHeight)) window.scrollTo({ top: window.pageYOffset + r.top - 90, behavior: 'smooth' });
      })
      .catch(function (e) {
        if (e && e.codigo === 'EXPIRADO') { erro('Sua sessão expirou. Recarregue a página para continuar.'); return; }
        if (e && e.codigo === 'SEM_SALDO') { erro(''); return; }
        erro(e && e.message ? e.message : 'Não deu certo. Tente outras fotos.', true); xodoOferecer(e);
      })
      .then(function () { clearInterval(relogio); estado.gerando = false; el.status.hidden = true; el.previa.classList.remove('is-gerando'); atualizar(); });
  }
  if (login) {
    var qs = 'produto=caixa&c=' + encodeURIComponent(login.c) + '&ts=' + encodeURIComponent(login.ts) + '&t=' + encodeURIComponent(login.t);
    fetch(api + '/saldo?' + qs).then(function (r) { return r.json(); }).then(function (j) { aplicarSaldo(j); atualizar(); }).catch(function () {});
  }
  el.criar.addEventListener('click', gerar); el.refazer.addEventListener('click', gerar);

  // Sem a foto pronta não vai pro carrinho: o clique no comprar explica o que falta.
  if (botaoComprar) {
    botaoComprar.addEventListener('click', function (ev) {
      if (estado.pronto) return;
      ev.preventDefault(); ev.stopImmediatePropagation();
      el.aviso.hidden = false; el.aviso.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
  }
  // Prévia acompanha o tamanho escolhido (Pequena / Grande).
  function tamanho() {
    var marcado = area.querySelector('input[type="radio"][name^="options"]:checked, input[type="radio"][name="Tamanho"]:checked');
    var sel = area.querySelector('select[name^="options"]');
    var v = (marcado && marcado.value) || (sel && sel.value) || '';
    var grande = /grande/i.test(v);
    el.previa.classList.toggle('is-grande', grande);
    if (frente) frente.src = frente.getAttribute(grande ? 'data-grande' : 'data-pequena');
  }
  area.addEventListener('change', function () { setTimeout(tamanho, 0); });
  tamanho(); pintarFotos(); atualizar();

  // ── 1 caixa = 1 peça (regra do Sergio, 01/11) ────────────────────────────────────────────────
  // Ao comprar a caixa, se o carrinho tem mais peças do que caixas, pergunta: uma caixa por peça, ou
  // só 1 caixa — e aí pede qual peça vai de presente, gravada na observação do pedido (cart note).
  var liberado = false;
  var qtdInput = area.querySelector('input[name="quantity"]') || document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
  var aviso = document.createElement('div'); aviso.className = 'xodoc__umacaixa'; aviso.hidden = true;
  aviso.setAttribute('role', 'dialog'); aviso.setAttribute('aria-live', 'polite');
  aviso.style.cssText = 'margin:14px 0;padding:14px;border:2px solid #111;background:#fff;font-size:.85rem;line-height:1.45';
  // embaixo da linha inteira de comprar (quantidade + botão), na largura toda
  var linhaCompra = botaoComprar && botaoComprar.parentNode;
  if (linhaCompra && linhaCompra.parentNode) linhaCompra.parentNode.insertBefore(aviso, linhaCompra.nextSibling);
  function ehCaixa(it) { return it.handle === 'embalagem-meu-xodo' || /embalagem/i.test(it.product_type || ''); }
  function seguir() { liberado = true; aviso.hidden = true; botaoComprar.click(); setTimeout(function () { liberado = false; }, 1500); }
  function perguntar(pecas, caixasNoCarrinho, notaAtual) {
    var faltam = Math.max(1, pecas - caixasNoCarrinho);
    aviso.innerHTML = '<strong style="display:block;margin-bottom:4px">A caixa de presente cabe 1 peça.</strong>' +
      'Você tem ' + pecas + ' peças no carrinho. Quer uma caixa para cada uma?' +
      '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px">' +
      '<button type="button" class="btn btn--primary btn--solid" data-umacaixa="todas" style="flex:1;min-width:150px">Uma caixa para cada peça (' + faltam + ')</button>' +
      '<button type="button" class="btn btn--secondary" data-umacaixa="uma" style="flex:1;min-width:150px">Só 1 caixa</button></div>' +
      '<div data-umacaixa-qual hidden style="margin-top:12px"><label style="display:block;font-weight:700;margin-bottom:4px" for="xodo-qual-peca">Qual peça vai na caixa de presente?</label>' +
      '<input id="xodo-qual-peca" type="text" maxlength="120" placeholder="Ex.: a camiseta Romance, tamanho M" style="width:100%;padding:10px;border:1px solid #111">' +
      '<p style="margin:6px 0 0;font-size:.78rem">A gente coloca na observação do pedido.</p>' +
      '<button type="button" class="btn btn--primary btn--solid" data-umacaixa="ok" style="width:100%;margin-top:8px">Confirmar e adicionar</button>' +
      '<p data-umacaixa-erro hidden style="margin:6px 0 0;color:#b00020">Escreva qual peça vai na caixa.</p></div>';
    aviso.hidden = false; aviso.scrollIntoView({ behavior: 'smooth', block: 'center' });
    aviso.onclick = function (ev) {
      var b = ev.target.closest('[data-umacaixa]'); if (!b) return;
      var acao = b.getAttribute('data-umacaixa');
      if (acao === 'todas') { if (qtdInput) { qtdInput.value = faltam; qtdInput.dispatchEvent(new Event('change', { bubbles: true })); } seguir(); }
      else if (acao === 'uma') { if (qtdInput) qtdInput.value = 1; aviso.querySelector('[data-umacaixa-qual]').hidden = false; aviso.querySelector('#xodo-qual-peca').focus(); }
      else if (acao === 'ok') {
        var qual = aviso.querySelector('#xodo-qual-peca').value.trim();
        if (!qual) { aviso.querySelector('[data-umacaixa-erro]').hidden = false; return; }
        var nota = (notaAtual ? notaAtual + '\n' : '') + 'Caixa de presente Meu Xodó: ' + qual;
        fetch('/cart/update.js', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ note: nota }) })
          .catch(function () {}).then(seguir);
      }
    };
  }
  if (botaoComprar) botaoComprar.addEventListener('click', function (ev) {
    if (liberado || !estado.pronto) return;          // sem a foto pronta, o aviso de foto (acima) já segura
    ev.preventDefault(); ev.stopImmediatePropagation();
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      var pecas = 0, caixas = 0;
      (c.items || []).forEach(function (it) { if (ehCaixa(it)) caixas += it.quantity; else pecas += it.quantity; });
      var novas = parseInt((qtdInput && qtdInput.value) || '1', 10) || 1;
      if (pecas > 1 && caixas + novas < pecas) perguntar(pecas, caixas, c.note || ''); else seguir();
    }).catch(seguir);
  }, true);
})();
